<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 13.697 18.228"
  >
    <g id="Group_787" data-name="Group 787" transform="translate(-1.788 1.242)">
      <path
        id="Path_24"
        data-name="Path 24"
        d="M30.14,8.825V23.584a.678.678,0,0,1-.68.675H18.82a.678.678,0,0,1-.68-.675V13.2L23.209,8.15h6.25A.678.678,0,0,1,30.14,8.825Z"
        transform="translate(-15.405 -8.024)"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        id="Path_25"
        data-name="Path 25"
        d="M24.719,8.983l.017,5.7H19.271Z"
        transform="translate(-16.314 -8.983)"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1"
      />
    </g>
  </svg>
</template>
